import { CTA } from '../jdscontentblock/interface';
import { IPROP_MAP } from '../../generators/modifyProps';
import { JDSNotificationButtonProps } from '../jdsnotificationbutton/generated';
import { JDSToastProps } from './generated';
import { NotificationProps } from '../jdsnudge/logic';
import { ReactElement } from 'react';
import { resolvePropObjectKeys } from '../../utils/componenthelpers';

export interface ToastProps
  extends Omit<
    NotificationProps,
    'onShow' | 'onClose' | 'icon' | 'suffix' | 'prefix'
  > {
  id?: string;
  title?: string;
  onShow?: (id: string) => void;
  onClose?: (id: string) => void;
  dismissAfter?: number;
  icon?: JDSToastProps['prefix'];
  suffix?:
    | JDSNotificationButtonProps
    | ReactElement<JDSNotificationButtonProps>;
  prefix?: string | JDSToastProps['prefix'];
}

export const PROP_MAP: IPROP_MAP<ToastProps> = (props) => {
  return {
    primaryCTA: {
      properties: {
        primaryCTA: resolvePropObjectKeys(props.primaryCTA, 'title', ''),
        onPrimaryClick: (props.primaryCTA as CTA)?.onClick
      }
    },
    secondaryCTA: {
      properties: {
        secondaryCTA: resolvePropObjectKeys(props.secondaryCTA, 'title', ''),
        onPrimaryClick: (props.secondaryCTA as CTA)?.onClick
      }
    }
  };
};
